import $ from 'jquery';

import type { Language, LanguageVariant } from '@luna/i18n';
import { getCurrentLanguage, initI18n, isLanguageKeysModeActive, t } from '@luna/i18n';
import { getFeatureConfig } from '@luna/feature-config';
import { setYupLocale } from '@luna/form2';
import { getRetailLocalesBasePath, setCzCurrencySignByLanguage } from '@retail/core';
import { isFeatureEnabled } from '@luna/gatekeeper';
import { resolveLanguageOverrides } from '@shared/core';

function setupLibrariesLang(): void {
    const language = getCurrentLanguage();
    $.datepicker.setDefaults($.datepicker.regional[language]);
}

function setSkipLinkTranslations(): void {
    $('#skipLinkMainContainer').html(t('accessibility.skipLink0'));
    $('#skipLinkHelpButton').html(t('accessibility.skipLink2'));
}

function getAvailableLanguages(): LanguageVariant[] {
    const availableLanguages = getFeatureConfig(
        (featureConfig) => featureConfig.base.availableLanguages,
    );

    if (isFeatureEnabled((f) => f.syntheticLanguages)) {
        return [
            ...availableLanguages,
            ...(getFeatureConfig((config) => config.base.supportedSyntheticLanguages) ?? []),
        ] as LanguageVariant[];
    }

    return availableLanguages;
}

export async function initRetailI18n(language: Language): Promise<void> {
    await initI18n({
        currentLanguage: isLanguageKeysModeActive() ? 'cimode' : resolveLanguageOverrides(language),
        fallbackLanguage: getFeatureConfig((featureConfig) => featureConfig.base.defaultLanguage),
        availableLanguages: getAvailableLanguages(),
        localesBasePath: getRetailLocalesBasePath(),
        additionalLocaleLocations: isFeatureEnabled((f) => f.syntheticLanguages)
            ? ['/synthLocales/{{lng}}/{{ns}}.{{lng}}.json']
            : [],
    });
    setupLibrariesLang();
    setSkipLinkTranslations();
    setCzCurrencySignByLanguage(language);
    setYupLocale(t);
}
